import Api from '@/services/api'

export default {
  salvarTutorialCenario (value) {
    const dados = {
      'tutorial_cenario': value
    };

    new Api().post('Usuario/salvarTutorialCenario', dados);
  }
}
